"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _AdsActions = require("../actions/AdsActions");

var _fluxActions = require("flux-actions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  installPixelModalOpen: false,
  openLeadSyncingModal: null,
  leadSyncingEntityToUnsubscribe: null
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _AdsActions.AdsActionTypes.OPEN_INSTALL_PIXEL_MODAL, function (state) {
  return state.set('installPixelModalOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _AdsActions.AdsActionTypes.OPEN_MANAGE_LEAD_SYNCING_MODAL, function (state, action) {
  var network = action.payload.data;
  return state.set('openLeadSyncingModal', network);
}), (0, _defineProperty2.default)(_handleActions, _AdsActions.AdsActionTypes.OPEN_UNSUBSCRIBE_LEAD_SYNCING_ENTITY_MODAL, function (state, action) {
  var entity = action.payload.data;
  return state.set('leadSyncingEntityToUnsubscribe', entity);
}), (0, _defineProperty2.default)(_handleActions, _AdsActions.AdsActionTypes.CLOSE_MODAL, function () {
  return initialState;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;